// extracted by mini-css-extract-plugin
export default {"scrollable":"TablesList_scrollable__9p4q4","even":"TablesList_even__c0hhd","odd":"TablesList_odd__VRiNr"};